// src/marketing/editorial/Countdown.tsx
import { JSX } from 'react'

type Props = {
  launchDate: string | null
}

/**
 * Calcule J-N / J0 / J+N depuis aujourd'hui (UTC).
 * Réutilise la même arithmétique UTC que src/marketing/launch/dates.ts
 * (setUTCDate / toISOString().slice(0,10)).
 */
function computeCountdown(launchDate: string): { label: string; dayStr: string; dateStr: string } {
  const todayStr = new Date().toISOString().slice(0, 10)
  const todayMs = new Date(todayStr).getTime()
  const launchMs = new Date(launchDate).getTime()
  const diffDays = Math.round((launchMs - todayMs) / 86_400_000)

  let label: string
  let dayStr: string

  if (diffDays > 0) {
    label = 'Lancement dans'
    dayStr = `J-${diffDays}`
  } else if (diffDays === 0) {
    label = 'Lancement'
    dayStr = 'Jour J'
  } else {
    label = 'Lancé depuis'
    dayStr = `J+${Math.abs(diffDays)}`
  }

  return { label, dayStr, dateStr: launchDate }
}

export function Countdown({ launchDate }: Props): JSX.Element {
  if (launchDate === null) {
    return (
      <div className="xcountdown">
        <span className="k">Lancement</span>
        <span className="v">—</span>
      </div>
    )
  }

  const { label, dayStr, dateStr } = computeCountdown(launchDate)

  return (
    <div className="xcountdown">
      <span className="k">{label}</span>
      <span className="v">{dayStr}</span>
      <span className="d">{dateStr}</span>
    </div>
  )
}
